module.exports = __webpack_public_path__ + "img/Revenue per order Icon - white.5946ec01.svg";